import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";

import Header from "@/components/site/Header";
import Hero from "@/components/site/Hero";
import Marquee from "@/components/site/Marquee";
import Categories from "@/components/site/Categories";
import Lookbook from "@/components/site/Lookbook";
import Collection from "@/components/site/Collection";
import Catalog from "@/components/site/Catalog";
import Story from "@/components/site/Story";
import Testimonials from "@/components/site/Testimonials";
import Visit from "@/components/site/Visit";
import Inquiry from "@/components/site/Inquiry";
import Footer from "@/components/site/Footer";
import FloatingWhatsApp from "@/components/site/FloatingWhatsApp";

const HomePage = () => (
  <>
    <Header />
    <main>
      <Hero />
      <Marquee />
      <Categories />
      <Lookbook />
      <Collection />
      <Catalog />
      <Story />
      <Testimonials />
      <Visit />
      <Inquiry />
    </main>
    <Footer />
    <FloatingWhatsApp />
  </>
);

function App() {
  return (
    <div className="App">
      <Toaster
        position="bottom-left"
        richColors
        toastOptions={{
          style: {
            fontFamily: "'Outfit', sans-serif",
            borderRadius: 2,
          },
        }}
      />
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="*" element={<HomePage />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
